import React from 'react';
import isNil from 'lodash/isNil';
import { SelectInput } from 'react-admin';
import { getInheritedValue } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { useRateControllerContext } from '../rateController/RateControllerContext';

type Props = {
  source: string;
  inheritedSettings: any;
};

export const RateStructureSelect = ({ source, inheritedSettings }: Props) => {
  const { setRateStructure } = useRateControllerContext();

  const inheritedStructure = getInheritedValue(inheritedSettings, 'use_blended_rate');
  const helperText = isNil(inheritedStructure)
    ? ''
    : inheritedStructure
    ? '12 hour rate'
    : '8 hour rate';

  function onChangeRateStructure(event: React.ChangeEvent<HTMLInputElement>) {
    const selectedValue = event.target.value as unknown as boolean;
    setRateStructure(selectedValue);
  }

  return (
    <SelectInput
      source={`${source}.use_blended_rate`}
      choices={[
        { id: false, name: '8 hour rate' },
        { id: true, name: '12 hour rate' },
      ]}
      label="Rate Structure"
      emptyText="Apply inheritance"
      onChange={onChangeRateStructure}
      helperText={helperText}
    />
  );
};
